Vendd.Scripts.load(function () {
    var $wrapper = $('.x-control.x-pager[data-control="pager"]');

    if ($wrapper.length < 1) return;

    var wrapper = $wrapper.get(0),
        model = null;

    var scrolled = $wrapper.data('scrolled') === true;

    wrapper.bind = function () {
        if (!isTouch()) updatePagerLinks();
		customPagination();
        initPageSize();
        initComboPages();
    };

    wrapper.update = function () {
        var html;
        if (scrolled) {
           html = Vendd.Handlebars.parse("plPager_B", model);
        } else {
           html = Vendd.Handlebars.parse("plPager_A", model);
        }
        
        $wrapper.html(html);
        wrapper.bind();
    };

	function updatePagerLinks() {
		$('.pager').each(function (index, wrapper) {
			var $wrapper = $(wrapper); 
			//check if main product list product folder
			if ($wrapper.data('id') !== 'products') return;
			var pageSizes = $('[data-format-url="pagesize"]', $wrapper);
			var pageJumps = $('[data-format-url="page"]', $wrapper);
			var prev = $('[data-format-url="prevpage"]', $wrapper);
			var next = $('[data-format-url="nextpage"]', $wrapper);

			var url = window.location.href,
				parts = url.split('?'),
				newUrl, newParts;

			parts[0] = parts[0].replace(/\/P\d+\//i, '');

			//prev link
			newUrl = prev.attr('href');
			if (newUrl) {
				newParts = newUrl.split('?');
				newParts[0] = newParts[0].replace(/\/P\d+\//i, '');
				if (newParts[0] !== parts[0]) {
					newParts[0] = parts[0];
					if (newParts[0][newParts[0].length - 1] !== '/') {
						newParts[0] += '/';
					}
					if (parseInt(prev.attr('data-page') || 0) > 1)
						newParts[0] = newParts[0] + 'p' + prev.attr('data-page') + '/';
					
					prev.attr('href', newParts[0] + '?' + newParts[1]);
				}
			}

			//next link
			newUrl = next.attr('href');
			if (newUrl) {
				newParts = newUrl.split('?');
				newParts[0] = newParts[0].replace(/\/P\d+\//i, '');
				if (newParts[0] !== parts[0]) {
					newParts[0] = parts[0];
					if (newParts[0][newParts[0].length - 1] !== '/') {
						newParts[0] += '/';
					}
					if (parseInt(next.attr('data-page') || 0) > 1)
						newParts[0] = newParts[0] + 'p' + next.attr('data-page') + '/';
					next.attr('href', newParts[0] + '?' + newParts[1]);
				}
			}


			//page sizes
			pageSizes.closest('.x-pager-pagesizes').hide();
			//pageSizes.each(function (index, pageSize) {
			//	var $elem = $(pageSize);
			//	newUrl = $elem.attr('data-url');
			//	newParts = newUrl.split('?');
			//	if (newParts[0] !== parts[0]) {
			//		newParts[0] = parts[0].replace(/\/P\d+\//i, '');
			//		$elem.attr('data-url', newParts[0] + '?' + newParts[1]);
			//	}
			//});

			//pages
			pageJumps.each(function (index, pageJump) {
				var $elem = $(pageJump);
				newUrl = $elem.attr('data-url');
				newParts = newUrl.split('?');
				if (newParts[0] !== parts[0]) {
					newParts[0] = parts[0].replace(/\/P\d+\//i, '');
					if (newParts[0][newParts[0].length - 1] !== '/') {
						newParts[0] += '/';
					}
					if (parseInt($elem.val() || 0) > 1)
						newParts[0] += 'p' + $elem.val() + '/';
					$elem.attr('data-url', newParts[0] + '?' + newParts[1]);
				}
			});
		});

	}

			function initPageSize() {
				var $control = $('.x-control[data-control="pager"][data-type="pageSize"]');

				if ($control.length < 1) return;

				$control.each(function (i, item) {
					if (!isTouch()) $('select', item).sSelect({ ddMaxHeight: '200px' });

					$('select', item).change(function (e) {
						document.location = $(this).find(":selected").data('url');
					});
				});
    }

    function initComboPages() {
        var $control = $('.x-control[data-control="pager"][data-type="combopages"]');

        if ($control.length < 1) return;

        $control.each(function (i, item) {
            if (!isTouch()) $('select', item).sSelect({ ddMaxHeight: '200px' });

            $('select', item).change(function (e) {
                if ($(this).hasClass('disabled')) return;

                var element = $('.x-product-list li[data-page="' + $(this).find(":selected").val() + '"]');
                if (element.length > 0) {
                    $('html,body').animate({ scrollTop: element.eq(0).offset().top - 100 }, 600);
                    return;
                }
                document.location = $(this).find(":selected").data('url');
            });
        });
    }

	function customPagination() {

		//KV START oh my god code
		// How many pages can be around the current page
		var maxAround = 1;
		// How many pages are displayed if in beginning or end range
		var maxRange = 3;

		var $paginator = $('.pagination-numbers');

		var totalPages = $paginator.children('.pagination-links').length;

		if ( totalPages <= 10){
			$paginator.closest('.x-pager-combopages').removeClass('hidden');
			return;
		}

		var endRange = totalPages - maxRange;
		// Check if we're in the starting section
		var inStartRange = currentPage <= maxRange;
		// Check if we're in the ending section
		var inEndRange = currentPage >= endRange;
		// We need this for the span(s)
		var lastDotIndex = -1;
		var currentPage = $('.pagination-links.selected', $paginator).index() + 1;

		// Remove all dots
		//$('span.dots').remove();
		// Loop the pages
		$paginator.children('.pagination-links').each(function (page, element) {
			// Index starts at 0, pages at 1
			++page;
			var $element = $(element);
			if (page === 1 || page === totalPages) {
				// Always show first and last
				$element.show();
			} else if (inStartRange && page <= maxRange) {
				// Show element if in start range
				$element.show();
			} else if (inEndRange && page >= endRange) {
				// Show the element if in ending range
				$element.show();
			} else if (page === currentPage - maxAround || page === currentPage || page === currentPage + maxAround) {
				// Show element if in the wrap around
				$element.show();
			} else {
				// Doesn't validate, hide it.
				// Append dot if needed
				$element.hide();

				if (lastDotIndex === -1 || (! inStartRange && ! inEndRange && $('span.dots').length < 2 && page > currentPage)) {
					lastDotIndex = page;
					// Insert dots after this page, we only have one or 2, and we can only insert the second one
					// if we're not in the start or end range, and it's past the current page
					$element.after('<span class="dots">...</span>');
				}
			}
		});
		$paginator.closest('.x-pager-combopages').removeClass('hidden');
	}

    wrapper.bind();

    Vendd.MessageBus.subscribe(Vendd.ProductList.Messages.GetModelSuccess, $wrapper, function (envelope) {
        if (envelope.message.data.data.Products.Items.length < 1)
            return;

        model = envelope.message.data.data.Pager;        
        wrapper.update();
    });
});

